/* Valismo header behaviour:
   - Show on scroll up, recede (slide up + fade) on scroll down.
   - Always visible at the very top; hairline border appears once scrolled.
   - Mobile "Menü" toggle opens/closes the dropdown.
   All reads/writes are batched in a rAF so scrolling stays smooth. */
(function () {
  'use strict';

  function initScroll(header) {
    var lastY = window.pageYOffset || 0;
    var ticking = false;
    var SHOW_AT_TOP = 8;     /* px: always show within this of the top */
    var THRESHOLD = 6;       /* px: ignore tiny jitter */
    var HIDE_AFTER = 120;    /* px: only start hiding past the hero edge */

    function update() {
      ticking = false;
      var y = window.pageYOffset || 0;

      header.classList.toggle('valismo-header--scrolled', y > SHOW_AT_TOP);

      if (Math.abs(y - lastY) < THRESHOLD) {
        lastY = y;
        return;
      }

      if (y <= HIDE_AFTER || y < lastY) {
        /* near the top, or scrolling up -> show */
        header.classList.remove('valismo-header--hidden');
      } else {
        /* scrolling down -> recede, and close the mobile menu if open */
        header.classList.add('valismo-header--hidden');
        header.removeAttribute('data-open');
        var t = header.querySelector('[data-valismo-header-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      }

      lastY = y;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      },
      { passive: true }
    );

    update();
  }

  function initToggle(header) {
    var toggle = header.querySelector('[data-valismo-header-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', function () {
      var open = header.hasAttribute('data-open');
      if (open) {
        header.removeAttribute('data-open');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        header.setAttribute('data-open', '');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });

    /* close the menu after tapping a link */
    header.querySelectorAll('[data-valismo-header-mobile-nav] a').forEach(function (a) {
      a.addEventListener('click', function () {
        header.removeAttribute('data-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function init(header) {
    if (header.dataset.headerInit) return;
    header.dataset.headerInit = '1';
    initScroll(header);
    initToggle(header);
  }

  document.querySelectorAll('[data-valismo-header]').forEach(init);

  document.addEventListener('shopify:section:load', function (event) {
    var header = event.target.querySelector('[data-valismo-header]');
    if (header) init(header);
  });
})();
